import React from 'react';
import { Box, SxProps, Theme, useTheme, useMediaQuery } from '@mui/material';

interface HeaderResponsiveProps {
  children: React.ReactNode;
  border?: boolean;
  allowHorizontalOverflow?: boolean;
  sx?: SxProps<Theme>;
}

const HeaderResponsive: React.FC<HeaderResponsiveProps> = ({
  children,
  border = false,
  allowHorizontalOverflow = false,
  sx,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        transition: 'width 0.3s ease',
        px: { xs: 1, md: 1, xl: 1 },
        py: 1,
        maxWidth: '100%',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: allowHorizontalOverflow ? 'visible' : 'hidden',
        minWidth: 0,
        ...(isSmallScreen && {
          px: 1,
        }),
        ...(border && { border: '2px solid #1976d2' }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default HeaderResponsive;
